export default function () {
  const header = document.querySelector('.header');
  const menuBtn = header.querySelector('.header__btn');
  const mobileMenu = header.querySelector('.header-menu');
  const menuWrp = mobileMenu.querySelector('.header-menu__wrp');
  const callbackBot = header.querySelector('.header__callback-wrp');
  const dropdownList = header.querySelector('.header__dropdown');
  const navigationWrp = header.querySelector('.header__main');

  const elems = header.querySelectorAll('.header__item:not(.header__item--dropdown)');
  let elemsArray = [];
  if (elems) {
    elemsArray = [].slice.call(elems);
  }

  function setElemToDrop() {
    const filteredElems = elemsArray.filter(elem => !elem.classList.contains('header__item--hide'));
    if (filteredElems.length && dropdownList) {
      filteredElems[filteredElems.length - 1].classList.add('header__item--hide');
      filteredElems[filteredElems.length - 1].classList.add('header__item--absolute');
      const linkElem = filteredElems[filteredElems.length - 1].children[0];
      linkElem.classList.add('header__dropdown-link');
      linkElem.classList.remove('header__link');
      const copyElem = linkElem.cloneNode(true);
      if (!dropdownList.querySelector(`button[data-anchor="${copyElem.dataset.anchor}"]`)) {
        dropdownList.appendChild(copyElem);
      }
      return true;
    }
    return false;
  }

  function getElemFromDrop() {
    const filteredElements = elemsArray.filter(item => item.classList.contains('header__item--hide'));
    if (filteredElements && filteredElements.length && dropdownList) {
      const elem = filteredElements[filteredElements.length - 1];
      elem.classList.remove('header__item--absolute');
      if (navigationWrp.offsetWidth === navigationWrp.scrollWidth) {
        elem.classList.remove('header__item--hide');
        const btn = elem.querySelector('a');
        btn.classList.remove('header__dropdown-link');
        btn.classList.add('header__link');
        const elemDrop = dropdownList.querySelector(`a[href="${btn.getAttribute('href')}"]`);
        if (elemDrop) {
          dropdownList.removeChild(elemDrop);
        }
      } else {
        elem.classList.add('header__item--absolute');
      }
    }
  }

  if (menuBtn) {
    menuBtn.addEventListener('click', (e) => {
      e.preventDefault();
      window.bodyLock.disableBodyScroll(menuWrp);
      mobileMenu.classList.add('header-menu--open');

      setTimeout(() => {
        mobileMenu.classList.add('header-menu--show');
      }, 200);
    });
  }

  if (mobileMenu) {
    mobileMenu.addEventListener('click', (e) => {
      if (e.target === mobileMenu || e.target === mobileMenu.querySelector('.header-menu__close') || !mobileMenu.contains(e.target)) {
        window.closeMenu(mobileMenu, menuWrp);
      }
    });
  }

  if (callbackBot) {
    if (elems) {
      elemsArray = [].slice.call(elems);
    }
    if (dropdownList) {
      while (navigationWrp.offsetWidth < navigationWrp.scrollWidth) {
        if (setElemToDrop() === false) {
          break;
        }
      }
    }

    if (window.innerWidth >= 1280) {
      setTimeout(() => {
        if (navigationWrp.offsetWidth < navigationWrp.scrollWidth) {
          setElemToDrop();
        } else {
          getElemFromDrop();
        }
      }, 1000);
    }

    window.addEventListener('resize', () => {
      if (navigationWrp.offsetWidth < navigationWrp.scrollWidth) {
        setElemToDrop();
      } else {
        getElemFromDrop();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./new-blocks/header/header.js